import { ApplyEasy, ApplyMedium ,ApplyHard, ApplyCanvas, ApplyPaletteHint } from './ImageEditor.js';
if('serviceWorker' in navigator){
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js')
      .then( registration => {
      })
      .catch(error => {
        console.log(' service worker no work :( ', error);
      });
  });
}

class LRUCache {
  constructor(maxSize = 10) {
    this.maxSize = maxSize;
    this.cache = new Map();
  }

  get(key) {
    if (!this.cache.has(key)) return undefined;
    const value = this.cache.get(key);
    this.cache.delete(key);
    this.cache.set(key, value);
    return value;
  }

  set(key, value) {
    if (this.cache.has(key)) {
      this.cache.delete(key);
    }
    this.cache.set(key, value);
    if (this.cache.size > this.maxSize) {
      const firstKey = this.cache.keys().next().value;
      this.cache.delete(firstKey);
    }
  }

  has(key) {
    return this.cache.has(key);
  }

  clear() {
    this.cache.clear();
  }
}
class PriorityImageLoader{
  constructor() {
    this.highPriorityQ = [];
    this.lowPriorityQ = [];
    this.isProcessing = false;
    this.maxConcurrent = 4;
    this.activeLoads = 0;
  }

  async LoadHighPriority(url){
    return new Promise((resolve, reject) => {
      this.highPriorityQ.unshift({url, resolve, reject});
      this.ProcessQ();
    });
  }

  async LoadLowPriority(url){
    return new Promise((resolve, reject) => {
      this.lowPriorityQ.push({url, resolve, reject});
      this.ProcessQ();
    });
  }

  async ProcessQ(){
    if(this.isProcessing) return;
    this.isProcessing = true;

    while(this.activeLoads < this.maxConcurrent){
      const item = this.highPriorityQ.shift() || this.lowPriorityQ.shift();
      if(!item) break;

      this.activeLoads += 1;
      this.LoadImage(item).finally(() => {
        this.activeLoads -= 1;
        this.ProcessQ();
      });
    }

    this.isProcessing = false;
  }

  async LoadImage({url, resolve, reject}) {
    try {
      const img = new Image();
      img.crossOrigin = "Anonymous";

      const timeout = setTimeout(() => {
        reject(new Error(`Timeout loading ${url}`));
      }, 5000);

      img.onload = () => {
        clearTimeout(timeout);
        resolve(img);
      };

      img.onerror = (e) => {
        clearTimeout(timeout);
        reject(e);
      };

      img.src = url;
    } catch (error) {
      reject(error);
    }
  }
  
  CancelLowPriority(){
    this.lowPriorityQ.forEach(item => {
      item.reject(new Error('Cancelled'));
    });
    this.lowPriorityQ = [];
  }
}

class QuizInfo{
  constructor(generation, difficulty, offset, gen){
    this.pokemonList = ShufflePokemonList(generation);
    this.difficulty = difficulty;
    this.offset = offset;
    this.generation = gen;
    console.log(this);
  }
}
class PokemonInfo{
  constructor(name, typing, image, generation){
    this.name = name;
    this.typing = typing;
    this.generation = generation;
    this.height;
    this.weight;
    this.image = image;
    this.englishName;
    console.log(this);
  }
}

let currentRound = {
  name: '',
  nameListNotInUse: [],
  hintsRevealed: 0,
  nameListInUse: []
}

let hintList = [];
let hintTimer = null;
let hintIntervals = [];
let imageLoaded = false;
let timeLimit = 15000; // starting time limit, counting for milliseconds?
let timeLeft = timeLimit;
let timer = null;
let currentPokemon = null;
let currentQuiz = null;
let scoreCounter = 0;
let pkmnIndex = 0;
let cachedOffset = 0;
let initCanvas = document.getElementById('myCanvas');
let silhouette = document.getElementById('silhouette');
let timeElapsed = 0;
const MAX_CACHE_SIZE = 20;
const PREFETCH_BATCH = 8;
const LOW_WATERMARK = 5;

let pokemonQueue = [];
let isPrefetching = false;
let prefetchPKMNCache = new LRUCache(MAX_CACHE_SIZE);
let imageLoader = new PriorityImageLoader();
let selectedIndex = 0;
let selectedDivPkmn = '';

let sub_image = new Image();
sub_image.style.width = '192px';
sub_image.style.height = '192px';
let image = new Image();
image.style.width = '192px';
image.style.height = '192px';

sub_image.src = `assets/substitute.png`;
image.src = 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/206.png';
image.crossOrigin = "Anonymous";

var PKMN_AUTO_LIMIT = 5;
let cachedPokemonList = null;
// All html variables
let verify, input, output, divList, img, timerDisplay;
let startButton, submitButton, scoreText, skipButton;
document.addEventListener("DOMContentLoaded", function() {
    silhouette = document.getElementById('silhouette');
    //ctx = initCanvas.getContext('2d');
    document.getElementById('btn-easy').addEventListener('click', () => {
      ApplyEasy(initCanvas, sub_image);
    });

    document.getElementById('btn-mid').addEventListener('click', () => {
      ApplyMedium(initCanvas, sub_image);
    });

    document.getElementById('btn-hard').addEventListener('click', () => {
      ApplyHard(initCanvas, sub_image);
    });
    verify = document.getElementById("pokemon-verify");
    input = document.getElementById("pokemon-input");
    output = document.getElementById("pokemon-output");
    divList = document.getElementById("pokemon-list");

    submitButton = document.getElementById("submit");
    submitButton.addEventListener("click", VerifyPokemon);

    skipButton = document.getElementById("skip");
    skipButton.addEventListener("click", SkipRound);
    
    document.getElementById("start").addEventListener("click", InitGame);
    document.getElementById("return").addEventListener("click", ReturnToForm);

    scoreText = document.querySelectorAll(".score-text");
    img = document.getElementById("silhouette");
    input.addEventListener("keyup", FetchPokemonList);
    timerDisplay = document.querySelectorAll(".timer-text");

    AnimateDivClass('overlay-bg', 'STARTER_BG', 2, 750);
});

async function AnimateDivClass(className, imageName, numberOfFrames, animationSpeed){
    const imageClasses = document.querySelectorAll(`.${className}`);
    let step = 0;
    setInterval(AnimationPlayer, animationSpeed);
    function AnimationPlayer(){
      step =  (step + 1) % numberOfFrames;
      imageClasses.forEach(p => {
        let urlString = `url(assets/${imageName}_${step}.png)`;
        const img = new Image();
        img.src = `assets/${imageName}_${step}.png`;
        img.onload = () =>{
          p.style.backgroundImage = urlString;
        };
      });
    };
}

function SwithAnimationFrame(image, frame_name){
  const img = new Image();
  img.src = 
  image.style.backgroundImage = frame_name;
}

function UpdateSelection() {
  const items = [...divList.children];

  items.forEach((item, i) => {
    item.classList.toggle("selected", i === selectedIndex);
  });
}


document.addEventListener("keydown", (e) => {
  const listItems = divList.children;
  if (e.key === "ArrowDown") {
    e.preventDefault();
    if (listItems.length === 0) return;

    selectedIndex = Math.min(selectedIndex + 1, listItems.length - 1);
    //UpdateSelection();
  }

  if (e.key === "ArrowUp") {
    e.preventDefault();
    if (listItems.length === 0) return;

    selectedIndex = Math.max(selectedIndex - 1, 0);
    //UpdateSelection();
  }

  if (e.key === "Enter") {
    e.preventDefault();

    let value;

    if (selectedIndex >= 0) {
      value = listItems[selectedIndex].textContent;
    } else {
      value = input.value.trim();
    }

    selectedDivPkmn = value;

    if(value && imageLoaded){
      VerifyPokemon();
    }

    // if (value) {
    //   VerifyPokemon(value);
    // }
  }
})

document.querySelectorAll('.btn-group').forEach(group => {
    const firstBtn = group.querySelector('button[data-value]');
    if (firstBtn) firstBtn.classList.add('active');

    group.addEventListener('click', e => {
        const btn = e.target.closest('button[data-value]');
        if (!btn) return;
        // deactivate siblings
        group.querySelectorAll('button').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        // update hidden input that shares the group id (e.g. generation-group -> #generation)
        const hiddenId = group.id.replace('-group', '');
        const hidden = document.getElementById(hiddenId);
        if (hidden) hidden.value = btn.dataset.value;
    });
});

function ResetButtons(){
  document.querySelectorAll('.btn-group').forEach(group => {
      group.querySelectorAll('button').forEach(b => b.classList.remove('active'));
      const firstBtn = group.querySelector('button[data-value]');
      if (firstBtn) firstBtn.classList.add('active');
      const hiddenId = group.id.replace('-group', '');
      const hidden = document.getElementById(hiddenId);
      if (hidden) hidden.value = firstBtn.dataset.value;
  });
  
}

image.onload = () => {
  try{
    requestAnimationFrame(() => {
      imageLoaded = true;
      
      ApplyEasy(initCanvas, sub_image);
      ApplyCanvas(currentQuiz.difficulty, silhouette, image);
      PlayOneTimeAnimation(silhouette, 'spawnin');
      HideLoadingDisplay();
    });
  } catch (e) {
    HideLoadingDisplay();
    console.error("Error applying initial image:", e);
  }
  
};

async function LoadPokemonList() {
  if (cachedPokemonList !== null) {
    return cachedPokemonList; 
  }
  const response = await fetch('assets/pokemonList.txt');
  const txt = await response.text();
  const lines = txt
    .split('\n')
    .map(line => line.trim())
    .filter(line => line.length);
  cachedPokemonList = lines; 
  return lines;
}


async function PreparePokemon(name, isHighPriority = false){
    if(prefetchPKMNCache.has(name)){
      return prefetchPKMNCache.get(name);
    }
    try {
      const pokemonRes = await fetch(`https://pokeapi.co/api/v2/pokemon/${name}`);
      const pokemon = await pokemonRes.json();
      const speciesURL = pokemon.species.url;
      const speciesRes = await fetch(speciesURL);

      if (!pokemonRes.ok || !speciesRes.ok) {
        throw new Error(`Failed to fetch ${name}`);
      }
      const species = await speciesRes.json();
    let imageUrl =
      pokemon.sprites.other["official-artwork"].front_default;
      if (isHighPriority) {
        await imageLoader.LoadHighPriority(imageUrl);
      } else {
        // Don't await - let it load in background
        imageLoader.LoadLowPriority(imageUrl).catch(err => 
          console.warn(`Background load failed for ${name}:`, err)
        );
      }

    const prepared = {
      pokemon,
      species,
      imageUrl
    };

    prefetchPKMNCache.set(name, prepared);
    return prepared;
  }
  catch(error){
    console.error(error);
    throw error;
  }
}

function PreloadImage(url){
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => resolve(img);
      img.onerror = (e) =>reject(e);
      img.src = url;
    });
}

// The purpose of this is to always ensure a pokemon queue is fetched and ready to go
async function EnsurePrefetch() {

  // Doesnt call when this function is already running
  if (isPrefetching) return;
  // If enough is already prefetched, do nothing
  if (pokemonQueue.length >= LOW_WATERMARK) return;

  isPrefetching = true;
  try {

    // simple way of determining of where i am at in the quiz and determine which pokemon to prefetch next
    const startIndex = pkmnIndex + pokemonQueue.length;

    // slice out where i am at in the quiz and get the next batch of pokemon
    const namesToFetch = currentQuiz.pokemonList.slice(
      startIndex,
      Math.min(startIndex + PREFETCH_BATCH, currentQuiz.pokemonList.length)
    );

    // prepares all pokemon in parallel and waits for all to finish to ensure data exists
    const prepared = await Promise.all(
      namesToFetch.map(name => PreparePokemon(name, false))
    );

    // pushes all prepared pokemon to queue
    pokemonQueue.push(...prepared);
  } catch (err) {
    console.error("Prefetch error:", err);
  } finally {
    isPrefetching = false;
  }
}

async function SelectPokemon(){
  const MAX_RETRIES = 4;
    submitButton.disabled = true;
    skipButton.disabled = true;
    imageLoaded = false;
    pkmnIndex += 1;
    console.log()
    if(pkmnIndex >= currentQuiz.pokemonList.length){
      EndGame('complete');
      return null;
    }
    await EnsurePrefetch();

    
    let next = pokemonQueue.shift();
    if (!next) {
      await EnsurePrefetch();
      const currentPokemonName = currentQuiz.pokemonList[pkmnIndex];

      if(!currentPokemonName){
        console.error("No pokemon name at index", pkmnIndex);
        return null;
      }
      try {
        const prepared = await PreparePokemon(currentPokemonName, true);
        next = prepared;
      } 
      catch (error) {
        console.error("Failed to load current pokemon:", error);
        if (retryCount < MAX_RETRIES) {
          return await SelectPokemon(retryCount + 1);
        }
        ReturnToForm();
        return null;
      }
    }
    else {
      const imageUrl = next.imageUrl;
      
      await imageLoader.LoadHighPriority(imageUrl).catch(err => {
        console.warn("High priority load failed, using fallback:", err);
      });
    }

    const { pokemon: p, species: pSpecies, imageUrl } = next;

    currentPokemon = new PokemonInfo(
      pSpecies.names.map(n => TrimInput(n.name)),
      p.types.map(t => t.type.name),
      imageUrl,
      p.id
    );

    image.src = imageUrl;
    currentPokemon.englishName = pSpecies.names.find(n => n.language.name === 'en').name;
    currentPokemon.englishName = TrimInput(currentPokemon.englishName);
    currentPokemon.hintsRevealed = 0;
    skipButton.disabled = false;

    submitButton.disabled = false;

    return currentPokemon;
}

function GivePoints(hintsUsed){
    scoreCounter += 1;
    scoreText.forEach(t => {
      t.innerText = scoreCounter.toString();
    });
}

function ShufflePokemonList(list){
  for(let i = list.length - 1; i > 0; i--){
    const j = Math.floor(Math.random() * (i + 1));
    [list[i], list[j]] = [list[j], list[i]];
  }
  return list;
}

// Click on div element and the input bar will be autofilled with the correct spelling of name
function AutoFillInput(divElement){
    const p = divElement.querySelector('.pokemon-name');
    input.value = p.innerText;
    divList.replaceChildren(); 
}



// Depending on Input Value, filters the input for the first 5 pokemon matches
// i.e. if the input value is 'J', it returns the first 5 pokemon names that start with J
// This function is not case-sensitive
async function FetchPokemonList(){
  const inputVal = TrimInput(input.value);
  try {
    const lines = await LoadPokemonList();  // array of names
    let matches = [];
    if (inputVal !== "") {
      const regex = new RegExp(`^${inputVal}`, 'i');
      for (let line of lines) {
        if (regex.test(TrimInput(line))) {
          matches.push(line);
          if (matches.length === PKMN_AUTO_LIMIT) break;
        }
      }
    }
    output.innerText = matches.join('\n');
    GenerateDIVList(matches);
  }
  catch(err) {
    console.error("Error loading list:", err);
  }
}

function GenerateDIVList(matchList){
    divList.replaceChildren(); 
    for(let match of matchList){
        let pDiv = document.createElement('div');
        pDiv.className = 'pokemon-info';

        let pokemonName = document.createElement('p');
        pokemonName.className = 'pokemon-name';
        pokemonName.textContent = match;

        pDiv.addEventListener("click", () =>{
            AutoFillInput(pDiv);
        });
        pDiv.append(pokemonName);

        divList.append(pDiv);
    }
    UpdateSelection();
}

function ResetRound(){
  StopHintTimer();
  ShowLoadingDisplay();
  SelectPokemon().then( data =>{

    if(!data) return;
    input.value = "";
    currentRound.hintsRevealed = 0;
    currentRound.nameListNotInUse = ReturnUniqueCharList(data.englishName);
    currentRound.nameListInUse = [];
    ResetHints();
    DecideHints(
      currentQuiz.difficulty,
      currentQuiz.generation,
      currentPokemon.name
    );
    selectedIndex = 0;
    DisplayHiddenName(data.englishName);
  });
}

function TopFunction() {
  document.body.scrollTop = 0; 
  document.documentElement.scrollTop = 0; 
}

function ReturnUniqueCharList(name){
    const list = name.split("");
    const uniqueList = [...new Set(list)];
    return ShufflePokemonList(uniqueList);
}

function ResetHints(){
    // document.querySelectorAll('.hint').forEach( hint =>{
    //   hint.style.display = "none";
    // });
    const genNumber = document.querySelectorAll(".gen-number");

    genNumber.forEach(
      g => {
        g.innerText = '???';
      });

    document.querySelectorAll(".type1").forEach(
      t1 => {
        t1.src = `assets/types/UNOWN_TYPE.png`;
      });
    document.querySelectorAll(".type2").forEach(
      t2 => {
        t2.style.display = "none";
      }
    );
    
    
}

async function SkipRound(){
    skipButton.disabled = true;
    StopHintTimer();
    imageLoaded = false;
    currentRound.nameListInUse.concat(currentPokemon.nameListNotInUse);
    DisplayHiddenName(currentPokemon.englishName);
    const name = document.getElementById('name-hint');
    name.innerText = currentPokemon.englishName.toUpperCase();
    setTimeout(ResetRound, 500);
      
    // verify.innerText = 'skipped roun...';
}

async function VerifyPokemon(){
    let inputVal = input.value.toLowerCase();
    if(currentPokemon.name.includes(TrimInput(inputVal)) || currentPokemon.name.includes(TrimInput(selectedDivPkmn.toLowerCase()))){
        imageLoaded = false;
        StopHintTimer();
        currentRound.nameListInUse.concat(currentPokemon.nameListNotInUse);
        DisplayHiddenName(currentPokemon.englishName);
        const name = document.getElementById('name-hint');
        name.innerText = currentPokemon.englishName.toUpperCase();
        GivePoints(currentRound.hintsRevealed);
        ApplyEasy(silhouette, image);
        ShowTimerBonus(3000);
        
        setTimeout(ResetRound, 500);
        // add 3 seconds on correct ? change for difficulty?
        // verify.innerText = 'You gor ti right!';
    }
    else{
        PlayOneTimeAnimation(silhouette, 'shake');
        ShowTimerBonus(-250);
        // verify.innerText = 'wrong, idiot 〴⋋_⋌〵 ';
        DecideNextHint();
        
    }
    input.value = "";
    divList.replaceChildren(); 
}


function GenerationLimit(generation){
    switch(generation){
        case '1':
            return [0, 151];
        case '2':
            return [151, 251];
        case '3':
            return [251, 386];
        case '4':
            return [386, 493];
        case '5':
            return [493, 649];
        case '6':
            return [649, 721];
        case '7':
            return [721, 809];
        case '8':
            return [809, 905];
        case '9':
            return [905, 1025];
        default:
            return [0, 1025];
    }
}

async function GatherPokemonNames(gen) {
  let [x, y] = GenerationLimit(gen);
  try{
    const range = Math.max(y - x, 0);
    const interval = {
      offset: x,
      limit: range,
    }
    cachedOffset = x;
    const data = await fetch(`https://pokeapi.co/api/v2/pokemon?limit=${y-x}&offset=${x}`);
    return data.json();
  }
  catch(err){
      console.error("Failed to fetch pkmn data :/ - ", err);
      throw err;
    }
}

function TrimInput(name){
  name = name.toLowerCase();
  let trimmed = name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
  trimmed = trimmed.replace(/\s+/g, '');
  trimmed = trimmed.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,'');
  return trimmed;
}

function StartTimer(timeLimit){
    if(currentQuiz.difficulty === 'easy'){
      timeLimit = 45000;
    }
    if(currentQuiz.difficulty === 'medium'){
      timeLimit = 30000;
    }
    if(currentQuiz.difficulty === 'hard'){
      timeLimit = 25000;
    }
    timer = setInterval(countdown, 10);
    timeElapsed = 0;
    timeLeft = timeLimit;
    function countdown(){
      if(imageLoaded)
        {  if(timeLeft <= 0){
              clearInterval(timer);
              EndGame("timeout");
          } else {
              timeLeft -= 10;
              timeElapsed += 10;
              let seconds = Math.floor(timeLeft / 1000);
              let milliseconds = Math.floor((timeLeft % 1000) / 10);
              timerDisplay.forEach( t => {
                t.innerText = seconds + " : " + (milliseconds < 10 ? '00' : milliseconds);
              });
          } 
        }
      }
}

function StopTimer(){
    if(timer){
        clearInterval(timer);
        timer = null;
    }
}

function DecideHints(difficulty, gen, name){
  hintList.length = 0;
  hintIntervals.length = 0;
  
  hintIntervals = [1500, 2500, 3500, 5000];
  if(difficulty === 'medium'){
    hintIntervals = [2500, 3500, 5000, 7500];
  }
  else if(difficulty === 'hard'){
    hintIntervals = [2500, 5000, 7500, 10000];
  }
  if(gen == 0){
      if(difficulty == 'easy'){
          
          hintList = [
            DetermineNextLetter,
            DetermineTyping,
            DetermineGeneration,
            DetermineNextLetter
          ];
      }
      else{
        
          hintList = [
            DetermineNextLetter,
            DetermineTyping,
            DetermineGeneration,
            DetermineNextPalette
          ];
      }
      
    } 
    else {
      if(difficulty == 'easy'){
          hintList = [
            DetermineNextLetter,
            DetermineTyping,
            DetermineNextLetter,
            DetermineNextLetter
          ];
      }
      else{
          hintList = [
            DetermineNextLetter,
            DetermineTyping,
            DetermineNextLetter,
            DetermineNextPalette
          ];
      }
      DetermineGeneration();
    }
  StartHintTimer(); 
}
function StartHintTimer(){
  if(hintTimer) clearInterval(hintTimer);
  
  let roundStartTime = Date.now();
  
  hintTimer = setInterval(() => {
    if(!imageLoaded) return; 
    
    const elapsed = Date.now() - roundStartTime;
    
    // Check if it's time to reveal the next hint
    const nextHintIndex = currentRound.hintsRevealed;
    
    if(nextHintIndex < hintIntervals.length && 
       elapsed >= hintIntervals[nextHintIndex]){
      
      DecideNextHint();
    }
  }, 100); // Check every 100ms
}

function StopHintTimer(){
  if(hintTimer){
    clearInterval(hintTimer);
    hintTimer = null;
  }
}

function DecideNextHint(){
    if(currentRound.hintsRevealed < hintList.length){
      try {
        // call the next hint function
        const fn = hintList[currentRound.hintsRevealed];
        if (typeof fn === 'function') fn();
      } catch (e) {
        console.error("Error running hint:", e);
      }
      currentRound.hintsRevealed += 1;
    } else {
    }
  
}
function DetermineNextLetter(){
    const newLetter = currentRound.nameListNotInUse.pop();
    currentRound.nameListInUse.push(newLetter);
    
    DisplayHiddenName(currentPokemon.englishName);
}

function DetermineNextPalette(){
  
    ApplyPaletteHint(silhouette);
}

function DisplayHiddenName(pkmnName){
    const rawName = pkmnName.split('');
    let hintName = "";
    for(let i = 0; i < rawName.length; i++){
        const ch = rawName[i];

        if(currentRound.nameListInUse.includes(ch)){
            hintName += ch.toUpperCase();
        }
        else{
            hintName += "_";
        }
    }
    const name = document.getElementById('name-hint');
    if(name){
        name.innerText = hintName;
        name.classList.remove('animate-text-bounce');
        void name.offsetWidth;
        name.classList.add('animate-text-bounce');
    }
}

function ShowTimerBonus(bonusSeconds){
  timeLeft += bonusSeconds; 
  bonusSeconds = (bonusSeconds * 1.0)/ 1000;
  const timerElements = document.querySelectorAll('.time-bonus-holder');

  timerElements.forEach( t => {
    const bonus = document.createElement('div');
    
    bonus.className = 'time-bonus';
    if(bonusSeconds < 0){
      bonus.textContent = `${bonusSeconds}s`;
    }
    else{
      bonus.textContent = `+${bonusSeconds}s`;
    }
    
    
    const rect = t.getBoundingClientRect();
    t.appendChild(bonus);
    
    // Remove after animation completes
    setTimeout(() => {
        bonus.remove();
    }, 1500);
  })
}


function DetermineGeneration(){
  // compute generation from currentPokemon.id via GenerationLimit ranges
  const id = currentPokemon?.generation;
  let genText = 'Unknown Generation';
  if (id) {
    for (let gen = 1; gen <= 10; gen++){
      const [start, end] = GenerationLimit(String(gen));
      if ((id - 1) >= start && (id - 1) < end) {
        genText = `Generation ${gen}`;
        break;
      }
    }
  }
  const genNumber = document.querySelectorAll(".gen-number");
  genNumber.forEach(
    g => {
      g.classList.remove('animate-text-bounce');
      void g.offsetWidth;
      g.classList.add('animate-text-bounce');
      g.innerText = genText;
    });
}

function DetermineTyping(){
  document.getElementById("type-hint").style.display = "";
  // const type1 = document.getElementById("type1");
  // const type2 = document.getElementById("type2");
  // type1.src = `assets/types/${currentPokemon.typing[0]}.png`;
  const type1 = currentPokemon.typing[0].toUpperCase();
  document.querySelectorAll(".type1").forEach( 
      t1 => {
        t1.classList.remove('animate-type-pop');
        void t1.offsetWidth;
        t1.classList.add('animate-type-pop');
        t1.src = `assets/types/${type1}_TYPE.png`;
      });
  if(currentPokemon.typing.length === 1){
    document.querySelectorAll(".type2").forEach(
      t2 => {
        t2.style.display = "none";
      });
  }
  else if(currentPokemon.typing.length === 2){
    const type2 = currentPokemon.typing[1].toUpperCase();
    document.querySelectorAll(".type2").forEach(
      t2 => {
        t2.style.display = "";
        t2.classList.remove('animate-type-pop');
        void t2.offsetWidth;
        t2.classList.add('animate-type-pop');
        t2.src = `assets/types/${type2}_TYPE.png`;
      });
  }
}

function EndGame(reason){
    const endForm = document.getElementById("endgame");
    const endTitle = document.getElementById("end-title");
    StopHintTimer();
    StopTimer();
    if (reason === 'complete') {
      endTitle.innerText = "QUIZ COMPLETE!";
    } else {
      endTitle.innerText = "TIME IS UP!";
    }
    ReadQuiz();
    ReadTime();
    StartScoreCount(scoreCounter);
    endForm.style.display = "block";
    PlayOneTimeAnimation(endForm, 'spawnin');
}

function ReadTime(){
  const timerDisplay = document.getElementById('time-passed');
  let minutes = Math.floor(timeElapsed / 60000);
  let seconds = Math.floor((timeElapsed / 1000) % 60);
  let milliseconds = Math.floor((timeElapsed % 1000) / 10);
  timerDisplay.innerText= (minutes < 1 ? '' : minutes + 'm ') + seconds + 's ' + milliseconds + 'ms ';
}

function ReadQuiz(){
    const modeText = document.getElementById("quiz-mode");
    let genText = "";

    if(currentQuiz.generation == 0){
      genText = "All Generations";
    }
    else{
      genText = "Generation " + currentQuiz.generation;
    }
    let diffText = currentQuiz.difficulty.charAt(0).toUpperCase() + currentQuiz.difficulty.slice(1);
    let mode = genText + " - " + diffText;

    modeText.innerText = mode;
}

function StartScoreCount(finalScore){
    const scoreText = document.getElementById('final-score');
    let score = 0;
    timer = setInterval(scorecount, 1500/ finalScore);
    scoreText.innerText = score;
    function scorecount(){
        if(score == finalScore){
            if(finalScore == currentQuiz.pokemonList.length){
              const fsLabel = document.getElementById('endgame-score-label');
              document.querySelectorAll('.star').forEach(star =>{
                star.style.display = 'block';
              });
              fsLabel.classList.remove('animate-text-bounce');
              void fsLabel.offsetWidth;
              fsLabel.classList.add('animate-text-bounce');
              const fsScoreLabel = document.getElementById('final-score-label');
              fsScoreLabel.innerText = "PERFECT SCORE";

            }
            clearInterval(timer);
        } else {
            score += 1;
            scoreText.innerText = score;
        } 
      }
}

function PlayOneTimeAnimation(element, animationName){
  const animationClass = `animate-${animationName}`;
  element.classList.remove(animationClass);
  void element.offsetWidth;
  element.classList.add(animationClass);

  const onAnimationEnd = () => {
    element.classList.remove(animationClass);
    element.removeEventListener('animationend', onAnimationEnd);
  };

  element.addEventListener('animationend', onAnimationEnd);
}

function ReturnToForm(){
  currentQuiz = null;
  currentPokemon = null;
  ResetButtons();
    const form = document.getElementById("intake");
    form.style.display = "block";

    const endGame = document.getElementById("endgame");
    endGame.style.display = "none";

    document.querySelectorAll('.star').forEach(star =>{
        star.style.display = 'none';
      });
    const fsScoreLabel = document.getElementById('final-score-label');
    fsScoreLabel.innerText = "FINAL SCORE";
}

function ShowLoadingDisplay(){
  const overlay = document.getElementById('loading-overlay');
  overlay.style.display = "flex";
}

function HideLoadingDisplay(){
  const overlay = document.getElementById('loading-overlay');
  overlay.style.display = "none";
}

function InitGame(){
    // Selects Pokemon and Initiates Shaders
    let form = document.querySelectorAll(".overlay").forEach(
      form => {
          form.style.display = 'none';
    });

    scoreCounter = 0;
    pkmnIndex = -1;
    TopFunction();

    imageLoader.CancelLowPriority();
    const generation = document.getElementById("generation").value;
    const difficulty = document.getElementById("difficulty").value;
    GatherPokemonNames(generation).then(async data => {
      
      input.value = '';
      FetchPokemonList();
      ShowLoadingDisplay();
      scoreText.forEach(t => {
        t.innerText = "0";
      });
      let names = (data.results ||  []).map(p => p.name);
      pokemonQueue = [];
      prefetchPKMNCache.clear();
      currentQuiz = new QuizInfo(names, difficulty, cachedOffset, generation);
      if (names.length > 0) {
        await PreparePokemon(names[0], true);
      }
      await EnsurePrefetch();
      ResetRound();
      StartTimer(timeLimit);
    });
}

ApplyEasy(initCanvas, sub_image);